var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('audio',{ref:"audioPlayer",attrs:{"src":_vm.currentAudio,"hidden":""},on:{"canplay":function($event){_vm.onCanplay()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }